export const cleanString = (str: string, whitespaceCharacters?: string[]): string => {
  let clean = str.replace(/\s+/g, ' ').trim().toLowerCase();

  if (!Array.isArray(whitespaceCharacters) || whitespaceCharacters.length === 0) {
    return clean;
  }
  const whitespaceRegex = new RegExp(whitespaceCharacters.join('|'), 'gi');
  clean = clean.replace(whitespaceRegex, ' ').trim();
  return clean;
};
